import React from "react";
import { useI18n } from "../lib/i18n.jsx";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 mb-5">
      <div className="min-w-0">
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight break-words">{title}</h1>
        {subtitle && <p className="text-[var(--text-3)] text-sm mt-1">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap gap-2 max-w-full">{action}</div>
    </div>
  );
}

export function StatCard({ label, value, sub, accent, icon: Icon }) {
  return (
    <div className={`tactical-card p-4 min-w-0 overflow-hidden ${accent ? "kpi-accent" : ""}`}>
      <div className="flex items-center justify-between gap-2 min-w-0">
        <span className="text-xs uppercase tracking-wider text-[var(--text-3)] font-semibold min-w-0 break-words">{label}</span>
        {Icon && <Icon size={16} className="text-[var(--amber)] shrink-0" />}
      </div>
      <div className="font-mono-num text-2xl font-bold mt-2">{value}</div>
      {sub && <div className="text-xs text-[var(--text-3)] mt-1">{sub}</div>}
    </div>
  );
}

const STATUS_COLORS = {
  draft: "bg-slate-100 text-slate-600",
  submitted: "bg-blue-100 text-blue-700",
  in_review: "bg-amber-100 text-amber-700",
  approved: "bg-emerald-100 text-emerald-700",
  rejected: "bg-red-100 text-red-700",
  active: "bg-emerald-100 text-emerald-700",
  planning: "bg-blue-100 text-blue-700",
  paused: "bg-amber-100 text-amber-700",
  completed: "bg-slate-200 text-slate-700",
  blocked: "bg-red-100 text-red-700",
};

export function StatusPill({ status }) {
  const { t } = useI18n();
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${STATUS_COLORS[status] || "bg-slate-100 text-slate-600"}`}>
      {t(status) === status ? status : t(status)}
    </span>
  );
}

export function Empty({ text }) {
  const { t } = useI18n();
  return <div className="tactical-card p-10 text-center text-[var(--text-3)]">{text || t("no_data")}</div>;
}

export function Restricted() {
  const { t } = useI18n();
  return <span className="inline-flex items-center gap-1 text-xs text-[var(--text-3)]">🔒 {t("restricted")}</span>;
}
